module.exports = __webpack_public_path__ + "img/Slide14.40248a5c.png";